import { render, staticRenderFns } from "./PurchaseOrderList.vue?vue&type=template&id=582eb4f6&scoped=true"
import script from "./PurchaseOrderList.vue?vue&type=script&lang=ts"
export * from "./PurchaseOrderList.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseOrderList.vue?vue&type=style&index=0&id=582eb4f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582eb4f6",
  null
  
)

export default component.exports